(function () {

  function setNativeValue(input, value) {
    const nativeSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, 'value'
    ).set;
    nativeSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function buildProductString() {
    const title = document.querySelector('h1')?.textContent?.trim() || '';
    const parts = [title];

    // Add each selected variant option (skip sticky clones and colour swatches)
    document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
      const name = radio.name;
      if (!name || name.includes('sticky') || name.includes('colour')) return;
      parts.push(name + ': ' + radio.value);
    });

    return parts.join(' | ');
  }

  function updateProductField() {
    const embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return false;
    const productInput = embed.shadowRoot.querySelector('#custom\\#product');
    if (!productInput) return false;
    setNativeValue(productInput, buildProductString());
    return true;
  }

  // Poll until the shadow DOM input is ready, then set the value
  function pollAndFill(attemptsLeft) {
    if (updateProductField()) return; // success
    if (attemptsLeft > 0) {
      setTimeout(() => pollAndFill(attemptsLeft - 1), 150);
    }
  }

  // ✅ KEY FIX: wait for the custom element to be defined (fires after deferred scripts load)
  // then poll briefly in case React hasn't rendered the inputs yet
  customElements.whenDefined('shopify-forms-embed').then(() => {
    pollAndFill(20); // up to ~3 seconds of polling at 150ms intervals
  });

  // Listen for variant changes and update immediately
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (
      target.tagName === 'INPUT' &&
      target.type === 'radio' &&
      !target.name.includes('sticky') &&
      !target.name.includes('colour')
    ) {
      updateProductField();
    }
  });

})();